// src/components/common/Card.jsx
import React from "react";

/**
 * Card: accepts header, footer via props or children
 */
export default function Card({ title, children, footer, className, style }) {
  return (
    <div
      className={`card ${className || ""}`}
      style={{ padding: 16, ...style }}
    >
      {title && (
        <div className="mb-3">
          <h4 className="text-md font-semibold text-gray-900 dark:text-white">
            {title}
          </h4>
        </div>
      )}
      <div className="text-gray-700 dark:text-gray-300">{children}</div>
      {footer && (
        <div className="mt-4 border-t border-gray-200 dark:border-gray-700 pt-3">
          {footer}
        </div>
      )}
    </div>
  );
}
